<template>
  <PSIntegrated />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
